import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import MaterialSelectModal from '@/assets/common/Modal/ItemSelectModal/MaterialSelectModal/MaterialSelectModal.vue'
import Modal from '@/assets/common/Modal/Modal.vue'
import { DepreicationAdd } from '@/types/Component';

type Material = {
    id: string;
    name: string;
    type: string;
    disabledCheck: boolean
}

@Component({
    components: {
        MaterialSelectModal,
        Modal,
    }
})
export default class DepreciationMaterialAddModal extends Vue {
    @Prop()
    private value!: boolean

    private title = '資材(減価償却)の追加'
    
    private form: DepreicationAdd = {
        material: {
            id: '',
            name: '',
            type: ''
        },
        displayName: '',
        purchaseDate: '',
        purchaseAmount: 0,
        depreciationPeriod: 0,
        depreciationTimes: 0,
    }

    private showMaterialSelectModal = false
    private initialMaterial: Material = {
        id: '',
        name: '',
        type: '',
        disabledCheck: false
    }

    private isAutoCalc = true

    get showDepreciationMaterialAddModal(): boolean {
        return this.value
    }
    set showDepreciationMaterialAddModal(b: boolean) {
        b
    }

    get timePerPeriod(): number {
        const { depreciationPeriod, depreciationTimes } = this.form
        const ret = (depreciationPeriod !== 0) && depreciationPeriod
            ? Math.round((depreciationTimes / depreciationPeriod) * 100) / 100
            : 0
        return ret
    }
    set timePerPeriod(n: number) {
        this.form.depreciationTimes = this.form.depreciationPeriod * n
    }

    get amountPerUnit(): number {
        const {purchaseAmount, depreciationTimes} = this.form
        const ret = depreciationTimes !== 0 && depreciationTimes
            ? Math.round((purchaseAmount / depreciationTimes) * 100 ) / 100
            : 0
        return ret
    }
    set amountPerUnit(n: number) {
        const depreciationTimes = n !== 0 && n
            ? Math.round((this.form.purchaseAmount / n) * 100) / 100
            : 0
        if(n !== 0) {
            this.form.depreciationTimes = this.form.purchaseAmount / n
        }
        else {
            this.form.depreciationPeriod = 0
            this.form.depreciationTimes = 0
        }
    }

    @Watch('value')
    whenOpen(): void {
        this.form = {
            material: {
                id: '',
                name: '',
                type: ''
            },
            displayName: '',
            purchaseDate: '',
            purchaseAmount: 0,
            depreciationPeriod: 0,
            depreciationTimes: 0,
        }
    }

    @Emit('save')
    commit(): DepreicationAdd | null {
        const errmsg: string[] = []
        // 名前の入力
        if (!this.form.displayName.trim()) {
            errmsg.push("資材名を入力してください")
        }
        // 名前の長さ
        if (this.form.displayName.length > 36) {
            errmsg.push(`倉庫名は36文字以内で入力してください（現在は${this.form.displayName.length}文字）`)
        }
        // 資材選択
        if (!this.form.material.id.trim()) {
            errmsg.push("資材を選択してください")
        }
        // 日付選択
        if (!this.form.purchaseDate.trim()) {
            errmsg.push("日付を選択してください")
        }
        // 購入金額
        if (this.form.purchaseAmount < 0) {
            errmsg.push("購入金額には0以上の整数を入力してください")
        }
        // 減価償却年数
        if (this.form.depreciationPeriod < 0) {
            errmsg.push("購入金額には0以上の整数を入力してください")
        }
        // 減価償却時間
        if (this.form.depreciationTimes < 0) {
            errmsg.push("購入時間には0以上の整数を入力してください")
        }

        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return null
        }

        return this.form
    }

    @Emit('cancel')
    cancel(): boolean {
        return true
    }

    // 資材選択モーダル
    openMaterialSelectModal(): void {
        this.showMaterialSelectModal = true
    }

    commitMaterial(material: Material): void {
        this.form.material = {
            id: material.id,
            name: material.name,
            type: material.type
        }
        this.showMaterialSelectModal = false
    }

}